import { SwitchInlineEditor } from 'components/inline_edit/ToggleInlineEditor';
import { usePermissions } from 'contexts/PermissionsContext';
import { CorporationsTableCellProps } from 'pages/Settings/Corporations/CorporationsTable';
import { updateCorporation } from 'utils/corporation';

export function CorporationActiveCell({ rowData, onChange }: CorporationsTableCellProps) {
    const { canEditCorporationSettings } = usePermissions();
    const onSave = async (newValue: boolean | undefined) => {
        if (newValue === undefined) {
            throw new Error('Attempted to save without active value');
        }
        try {
            onChange(await updateCorporation(rowData, { Active: newValue }));
        } catch {
            return 'Unable to save setting for corporation';
        }
        return undefined;
    };
    return (
        <SwitchInlineEditor
            onConfirm={onSave}
            value={rowData.Active}
            isDisabled={!canEditCorporationSettings}
        />
    );
}
